import React, { useCallback, useEffect, useState } from "react";
import Pager from "../../components/Pager";
import Stat from "../../components/Stat";
import { errorMessage } from "../../services";
import { getPayments } from "../../services/admin";
import { money } from "../../utils/format";
import PayModal from "./PayModal";
import PaymentHistory from "./PaymentHistory";
import SiteTable from "./SiteTable";
import useSiteActions from "./useSiteActions";

// Revenue overview, upcoming renewals, and the payment records behind them
export default function PaymentsTab({ user, notify }) {
  const [data, setData] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [error, setError] = useState("");
  const [version, setVersion] = useState(0); // bumped to reload the payment history too

  const load = useCallback(async () => {
    try {
      const { data: result } = await getPayments({ page: pageNumber, limit: 10 });
      setData(result);
      setError("");
    } catch (err) {
      setError(errorMessage(err));
    }
  }, [pageNumber]);

  useEffect(() => { load(); }, [load]);

  const reload = () => { load(); setVersion((v) => v + 1); };
  const actions = useSiteActions({ notify, reload });
  const summary = data && data.summary;
  const isSuper = user.role === "superadmin";

  return (
    <>
      <div className="page-heading">
        <div>
          <p className="eyebrow">REVENUE & COLLECTIONS</p>
          <h1>Payments</h1>
          <p className="subheading">Subscription overview and upcoming renewals.</p>
        </div>
      </div>
      {error && <div className="admin-error">{error}</div>}
      {summary && (
        <div className="stats-grid">
          <Stat label="Monthly recurring value" value={money(summary.monthlyRecurringRevenue)} meta="From running paid websites" icon="₹" />
          <Stat label="Payment due" value={summary.paymentDue} meta="Expired or due today" icon="◷" warn={summary.paymentDue > 0} />
          <Stat label="Trial websites" value={summary.trialWebsites} meta="On a free trial" icon="◉" />
          <Stat label="Partner rate" value={money(summary.partnerRate)} meta="Per website / month" icon="♧" />
        </div>
      )}

      <div className="panel table-panel">
        <div className="panel-heading"><div><h2>Renewal schedule</h2><p>Upcoming and overdue website plans.</p></div></div>
        <SiteTable sites={data ? data.schedule : []} user={user} loading={!data} onToggle={actions.toggle} onPay={actions.openPay} />
        {data && <Pager page={data.page} pages={data.pages} total={data.total} noun="websites" onPage={setPageNumber} />}
      </div>

      <PaymentHistory key={version} user={user} notify={notify} onChanged={load} />
      {actions.payTarget && <PayModal site={actions.payTarget} isSuperAdmin={isSuper} onSubmit={actions.pay} onClose={actions.closePay} />}
    </>
  );
}
